import { listRoutes as listLinkRoutes } from "./link";

export function listRoutes(group, { domain }) {
  const links = listLinks(group);
  if (links.length === 0) return [];

  const defaultUrl = group.defaultUrl || links[0].url;
  return links.reduce(
    (acc, link) => [...acc, ...listLinkRoutes(link, { domain, group })],
    [
      {
        key: group.id,
        type: "redirect",
        path: group.url,
        props: { to: defaultUrl }
      }
    ]
  );
}

export function listLinks(group) {
  if (!group) return [];
  return group.links || [];
}
